import React,{useEffect} from 'react'
import DeletedProductColumn from './deleted-product-column' 
import CommonTablePage, { CommonTablePagePropsInterface } from '../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../services/api/api-urls'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const DeletedProductPage: any = (props: any) => {

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.BaseProduct,
    getAllUrl: 'Product/GetAllDeletedProduct',
    title: props.title || 'Deleted Products',
    column: DeletedProductColumn(),
    isNotEditable: true,
    isNotDeletable: true,
    isNotAddable: true
  }
    useDocumentTitle();
  // useEffect(() => {   
  //   document.title="Deleted Products"
  // }, [])
  return (
    <>
      <CommonTablePage
        {...commonTablePageProps}
      />
    </>
  )
}

export default DeletedProductPage
